import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/data/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/data/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/data/${jobId}`;
